import React,{useState, useEffect, useRef}  from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom'
import {Header,Container, Button}  from 'semantic-ui-react'
import {v1 as uuid} from 'uuid'
import {useShop} from '../ShopContext'
import EditUser from './EditUser'

const EditSingleUser=(props)=>
{
    const {db}=props
    const path=useLocation().pathname.split('/')
    const {UID}=useParams()
    const history=useHistory()

    const [user,setUser]=useState(
        {
            UID:null,
            Vorname:'',
            Nachname:'',
            Strasse:'',
            Strasse2:'',
            PLZ:'',
            Ort:'',
            Land:'CH',
            mobil:'',
            Festnetz:'',
            email:'',
            attr:{},
            certified:'personal',
            Modus:'manuell',
            ShopId:''

        }
    )


    const hasError=useRef(false)
   
    useEffect(()=>{
        const getUser=async()=>{
            const myUser= await db.users.get(UID)
            setUser(myUser[0])
        }
        const newUser=async()=>
        {
            setUser(u=> ({...u,UID:uuid(),ShopId:''}))

        }
        if(path[1]==='new')
        {
           newUser()
        }
        else
        {
           getUser()
        }
    },[db])





    const afterSubmit=()=>
    {
        if(path[1]==='new')
        {

            setUser({
                UID:uuid(),
                Vorname:'',
                Nachname:'',
                Strasse:'',
                Strasse2:'',
                PLZ:'',
                Ort:'',
                Land:'CH',
                mobil:'',
                Festnetz:'',
                email:'',
                attr:{},
                certified:'personal',
                ShopId:'',
                Modus:'manuell'


            })
  
        }
        else
        {
            history.push('/show/kunde/'+user.UID+'/?data='+JSON.parse(user))
        }
    }

   

    return(
    <Container text>
        <Header>Benutzer ändern</Header>
        <EditUser
                user={user}
                setUser={setUser}
                afterSubmit={afterSubmit}
                db={db}
         /> 

    </Container>

    )
}

export default EditSingleUser
